<template>
  <div class="app">
    <Header></Header>
    <div id="content">
      <router-view :key="indexKey" />
    </div>
    <div class="backup" ref="backup" v-show="isShow" @click="toTop">
      <img src="./assets/ic_up.svg" class="up" />
      <div class="top">TOP</div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import $ from "jquery";
import { getLang } from "./common/utils";
export default {
  components: {
    Header,
  },
  data() {
    return {
      isShow: false,
    };
  },
  computed: {
    indexKey() {
      return Math.random();
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    const lang = getLang();
    if (lang === "en-US") {
      $("button, div, span, a").css("font-family", "SFUIText-Regular");
    } else {
      $("button, div, span, a").css("font-family", "SourceHanSansCN-Regular");
    }
  },
  methods: {
    handleScroll() {
      let scrolltop =
        document.documentElement.scrollTop || document.body.scrollTop;
      this.isShow = scrolltop > 30 ? true : false;
    },
    toTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop =
          document.documentElement.scrollTop =
          top -=
            50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
  },
};
</script>

<style>
@font-face {
  font-family: "SourceHanSansCN";
  src: url("./assets/font-zh/SourceHanSansCN-Medium.otf") format("truetype");
}
@font-face {
  font-family: "Montserrat-Light";
  src: url("./assets/font-zh/Montserrat-Light.otf") format("truetype");
}
@font-face {
  font-family: "SourceHanSansCN-Regular";
  src: url("./assets/font-zh/SourceHanSansCN-Regular.otf") format("truetype");
}

@font-face {
  font-family: "SFUIText-Semibold";
  src: url("./assets/font-en/SF-UI-Text-Semibold.otf") format("truetype");
}

@font-face {
  font-family: "SFUIText-Medium";
  src: url("./assets/font-en/SF-UI-Text-Medium.otf") format("truetype");
}
@font-face {
  font-family: "SFUIText-Regular";
  src: url("./assets/font-en/SF-UI-Text-Regular.otf") format("truetype");
}
@font-face {
  font-family: "SF-Mono";
  src: url("./assets/font-en//SF-Mono-Regular.otf") format("truetype");
}



a {
  text-decoration: none;
  color: inherit;
}

.backup {
  position: fixed;
  bottom: 230px;
  right: 10px;
  width: 40px;
  height: 40px;
  background: #a7afb9;
  border-radius: 4px;
  color: white;
  cursor: pointer;
  z-index: 9999;
}

.top {
  font-size: 12px;
  text-align: center;
}

.up {
  margin-left: 12px;
  margin-bottom: -3px;
  margin-top: 5px;
}

.el-dropdown-menu {
  background-color: #2b303b !important;
  border: none !important;
  top: 54px !important;
  border-radius: 0 !important;
  padding: 10px 40px 10px 0 !important;
  position: fixed !important;
}

.el-dropdown-menu__item {
  color: white !important;
}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: transparent !important;
  color: #597ef7 !important;
}

.el-popper .popper__arrow {
  display: none !important;
}

.el-button--text {
  color: white !important;
}

.el-button--text:hover {
  color: #597ef7 !important;
}

.el-button--primary {
  background-color: #597ef7 !important;
  border-color: #597ef7 !important;
  border-radius: 16px !important;
  padding: 8px 20px !important;
}

.el-button--primary.plain {
  border-color: black !important;
  color: black !important;
  background: white !important;
}

.el-button--primary.plain:hover {
  background-color: #597ef7 !important;
  border-color: #597ef7 !important;
  color: white !important;
}

.el-carousel__button {
  width: 60px !important;
  height: 4px !important;
}

.el-tabs__item {
  color: white !important;
  padding: 0 50px !important;
  font-size: 16px !important;
  height: 60px !important;
  line-height: 60px !important;
}

.el-tabs__item.is-active {
  color: #597ef7 !important;
}

.el-tabs__active-bar {
  background-color: #597ef7 !important;
  height: 3px !important;
}

.el-tabs__nav-scroll {
  display: flex;
  justify-content: center;
}

.el-tabs__nav-wrap::after {
  width: calc(100% - 160px) !important;
  left: 80px !important;
  background-color: #e4e7ed40 !important;
}

.el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 65px !important;
  line-height: 65px !important;
  color: white !important;
  font-size: 16px !important;
}

.el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
  display: none !important;
}

.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background-color: transparent !important;
  color: #597ef7 !important;
}

.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  background-color: #2b303b !important;
  color: white !important;
}

.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
   border-bottom: 3px solid #597ef7 !important;
   color: #597ef7 !important;
}

.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  color: #597ef7 !important;
}

.el-menu--horizontal > .el-menu {
  background-color: #2b303b !important;
  border: none !important;
}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: white;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  background-color: white;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background-color: #d8d8d8;
}
.el-menu--popup-bottom-start{
    margin-top: 1px !important;
  }
</style>
